import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSkateboardNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M9.96.46c-.028.234-.083.632-.16 1.049a9.808 9.808 0 01-.183.817c-.072.258-.139.425-.187.502l-.004.006-6.081 10.27c-.155.255-.4.466-.663.641-.187.124-.328.198-.46.267-.076.04-.149.079-.225.124l.692.762c.15-.08.363-.198.545-.32.324-.214.704-.524.967-.958L10.28 3.355c.13-.208.226-.492.3-.761.08-.284.147-.603.203-.903l.048-.273z" />
        <path
          clipRule="evenodd"
          d="M11.384 6.968a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 100-1 .5.5 0 000 1zm-4.53 8.702a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 100-1 .5.5 0 000 1z"
          fillRule="evenodd"
        />
      </g>
    </svg>
  )
);
SvgSportsSkateboardNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsSkateboardNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSkateboardNormalXsmall;
